import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllExpenses = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataExpenses, setDataExpenses] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllExpenses, setLoadingFetchAllExpenses ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-all-expenses`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllExpenses(true)
        fetchData()
            .then((resp) => {
                setDataExpenses(resp.rows)
                setLoadingFetchAllExpenses(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllExpenses(false)
            })
    }, [execute])

    return { dataExpenses, loadingFetchAllExpenses, executeFetch }

}

export const useFetchSpecificExpense = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificHouse, setLoadingFetchSpecificHouse ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idexpense: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-expense/${paramsToSearch.idexpense}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idexpense > 0 ){
            setLoadingFetchSpecificHouse(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idexpense: rows[0].idexpense || '',
                        descripcion: rows[0].descripcion || ''
                    }))
                    setLoadingFetchSpecificHouse(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificHouse(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificHouse, setParamsToSearch, executeFetch }

}